// 这边是关联单多选对标的查询方法

// 工坊加工具条查询
export function sourceSearch (item, search = [], key) {
    console.log('搜索', JSON.parse(JSON.stringify(item)), search)
      const arr = (item.list).map(its => {
        return {
            name: key ? its[key] : its.name,
            title: its.title,
            type: its.type
        }
    })
    // 搜索条件值
    const fileVal = []
    if (item.isToolbar) {
        for (const i of item.toolbarConfig) {
            console.log('搜索条件查询', i)
            // 搜索框搜索没有默认值
            if (i.type === 'screen') {
              if (i.FilterValue === 0 || i.FilterValue && i.FilterValue.length) {
                  const ita = i.list.list[i.checkValue]
                  if (arr.findIndex(ite => ite.name === ita.name) === -1) arr.push({ name: ita.name, title: ita.title, type: ita.type })
                  fileVal.push({
                      type: 'filter',
                      filterId: i.i,
                      dataconfig: {
                          rel: 'and',
                          where: [{
                              field: ita.name,
                              relation: 'in',
                            //   relation: 'like',
                              value: i.FilterValue
                          }],
                          // linked: [{
                          //         ...ita,
                          //         submitName: ita.name,
                          //         conditionValue: i.FilterValue,
                          //         condition: 'like'
                          //     }]
                      }
                  })
              }
            }
        }
    }
    console.log('两个值', arr, fileVal)
    // 拼接返回查询工坊数据
    const arrs = [{
        type: 'source',
        dataconfig: {
            reportid: item.relFormId,
            fields: arr.map(ite => ite.name),
            select: arr.map(ite => ite.name)
        },
        approvalId: item.relFormId,
        id: 1
    }]
    // 挂默认值数据
    for (const i of fileVal) {
        const id = arrs.length + 1
        i.id = id
        const pid = arrs[arrs.length - 1].id
        i.parentid = [pid]
        arrs.push(i)
    }
    // 挂搜索数据
    for (const i of search) {
        console.log('查看search理的i', i)
        if (!i) continue
        const id = arrs.length + 1
        i.id = id
        const pid = arrs[arrs.length - 1].id
        i.parentid = [pid]
        arrs.push(i)
    }
    console.log('返回值', arrs, search, fileVal)
    return arrs
  }

// 关联单选查询工坊配置条件
export function sourceNewRel (item, search = [], key, perty, formdata, flow = [], isRelation = false) {
    const { isSource, relFormId, list, dataconfig } = item
    console.log('工坊配置查询', isSource, relFormId, list, dataconfig, '查询', search, key)
    if (isSource != 2) return []
    const config = []
    const oneName = perty.map(it => it.name)
    const one = {
        type: 'source',
        dataconfig: {
            reportid: relFormId,
            fields: oneName,
            select: oneName
        },
        approvalId: relFormId,
        id: 1
    }
    config.push(one)
    if (dataconfig && dataconfig.linked && dataconfig.linked.conditional && dataconfig.linked.conditional.length > 0) {
        const two = {
            type: 'filter',
            dataconfig: {
                rel: 'and',
                where: []
            },
            id: 2
        }
        const twoObj = {}
        for (const i of dataconfig.linked.conditional) {
            if (!twoObj[i.currentfeild]) twoObj[i.currentfeild] = { field: i.currentfeild, relation: 'in', value: null }
            let value = formdata[i.feild]
            if (i.feild === '当前用户_relation-user') {
                try {
                    const user = JSON.parse(window.localStorage.getItem('userMsg'))
                    value = user.username
                } catch (err) { console.log(err) }
            }
            if (i.feild === '表单发起人_relation-user') {
                if (flow && flow.length > 0) {
                    value = flow[0].user.realname
                } else {
                    try {
                        const user = JSON.parse(window.localStorage.getItem('userMsg'))
                        value = user.username
                    } catch (err) { console.log(err) }
                }
            }
            if (value) {
                if (Array.isArray(twoObj[i.currentfeild].value)) {
                    twoObj[i.currentfeild].value.push(value)
                } else {
                    twoObj[i.currentfeild].value = [value]
                }
            }
            
        }
        two.dataconfig.where = Object.values(twoObj)
        two.parentid = [config[config.length - 1].id]
        config.push(two)
    }

    if (dataconfig && dataconfig.filter && dataconfig.filter.linked && dataconfig.filter.linked.length > 0) {
        const three = {
            type: 'filter',
            dataconfig: dataconfig.filter,
            id: 3,
            parentid: [config[config.length - 1].id]
        }
        config.push(three)
    }

    if (dataconfig && dataconfig.orders && dataconfig.orders.length > 0) {
        const four = {
            type: 'orders',
            dataconfig: {
                orderby: dataconfig.orders
            },
            parentid: [config[config.length - 1].id],
            id: 4
        }
        config.push(four)
    }

    if (search && search.length > 0) {
        for (const i of search) {
            if (i.type === 'search') {
                const three = {
                    type: 'filter',
                    filterId: i.i,
                    dataconfig: {
                      rel: 'and',
                      where: [
                        {
                          field: i.info.syllable.name || '',
                          relation: isRelation && i.value ? 'like' : 'in',
                          value: i.value || i.value === 0 ? isRelation ? i.value : [i.value] : null
                        }
                      ]
                    },
                    id: config[config.length - 1].id + 1,
                    parentid: [config[config.length - 1].id]
                }
                config.push(three)
            } else if (i.type === 'screen') {
                const three = {
                    type: 'filter',
                    filterId: i.i,
                    dataconfig: {
                      rel: 'and',
                      where: [
                        {
                          field: i.checkName || '',
                          relation: i.screenType === 'date' && Array.isArray(i.value) && i.value.length > 1 ? 'between' : i.activeName ? (i.activeName !== 'text' ? 'in' : 'like') : 'like',
                          value: i.value || null
                        }
                      ]
                    },
                    id: config[config.length - 1].id + 1,
                    parentid: [config[config.length - 1].id]
                }
                config.push(three)
            } else if (i.type === 'filter') {
                const three = JSON.parse(JSON.stringify(i))
                three.id = config[config.length - 1].id + 1
                three.parentid = [config[config.length - 1].id]
                config.push(three)
            }
        }
    }

    if (config.length > 1) {
        const fieldSys = {
            type: 'fieldSys',
            dataconfig: {
                fieldalias: list.map(it => {
                    return {
                        name: it.name,
                        alias: it.name,
                        formula: ''
                    }
                })
            },
            parentid: [config[config.length - 1].id],
            id: config[config.length - 1].id + 1
        }
        config.push(fieldSys)
    }

    return config
}